import {Workbook as Base} from '@mintdata-wsp/common/controllers/network/generated/responses/Workbook';
import {Tab} from '@mintdata-wsp/common/controllers/network/generated/responses/Tab';
import {CellStyleResponse} from '@mintdata-wsp/common/controllers/network/extended/responses/CellStyleResponse';

export class Workbook extends Base
{
    public readonly styles:Map<string, CellStyleResponse>;
    public readonly namedRanges:any;
    public readonly formats:any;
    public readonly sheets:Tab[];

    constructor(json:any)
    {
        super(json);

        this.styles = new Map();

        Object.keys(json['styles']).forEach((key:string) =>
        {
            const style = json['styles'][key];

            this.styles.set(key, new CellStyleResponse(style));
        });

        this.namedRanges = json['namedRanges'];
        this.formats = json['formats'];
        this.sheets = [];
        for( let i = 0, length = (json['sheets'] || []).length; i < length; i++ )
        {
            this.sheets.push(new Tab(json['sheets'][i]));
        }
    }
}
